import { Injectable, EventEmitter } from '@angular/core';
import { getBodyStyle, getColorVariables, getFontVariables } from './app-variables.utils';

@Injectable({
  providedIn: 'root'
})

export class AppVariablesService {
	variablesReload = new EventEmitter();

	getAppVariables() {
		const style = getBodyStyle();
		const font = getFontVariables(style);
		const color = getColorVariables(style);
		return { font, color };
	}
}
